import React, { Component } from 'react';
import { Card, List, Typography, Space, Tag, Button, Spin, Divider, Descriptions, Modal, message } from 'antd';
import { LeftOutlined, CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined, RightOutlined } from '@ant-design/icons';
import firebase from "../../firebase";

const { Text, Title } = Typography;
const nl2br = require('react-nl2br');

class MobileOrderDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: {},
            applyModal: false,
            applyId: null,
            applyTitle: null,
            rejectModal: false,
            rejectId: null,
            rejectTitle: null,
            waitModal: false,
            waitId: null,
            waitTitle: null,
            // Item action state
            itemActionLoading: false,
            cancelItemModal: false,
            cancelItemIndex: null,
            returnItemModal: false,
            returnItemIndex: null,
            cancelRejectModal: false,
            cancelRejectIndex: null,
            returnRejectModal: false,
            returnRejectIndex: null,
            divideModal: false,
            divideIndex: null,
        };
    }


    componentDidMount() {
        this.fetchOrderData();
    }

    fetchOrderData = async () => {
        const { db, id } = this.props;
        if (!id) return;

        try {
            const doc = await db.collection('orders').doc(id).get();
            if (doc.exists) {
                const data = doc.data();
                data.id = doc.id;

                // Item validation like OrderKaigawa.js
                const { userOrg, org } = this.props;
                let collection;
                if (org && org.reseller && userOrg && userOrg.maker) {
                    collection = db.collection('items_stock').doc(userOrg.id).collection('buyers').doc(org.id).collection('items');
                } else if (org && org.maker && userOrg && userOrg.reseller) {
                    collection = db.collection('items_stock').doc(org.id).collection('buyers').doc(userOrg.id).collection('items');
                } else if (org && org.reseller && userOrg && userOrg.buyer) {
                    collection = db.collection('items_sell').doc(userOrg.id).collection('items');
                } else if (org && org.buyer && userOrg && userOrg.reseller) {
                    collection = db.collection('items_sell').doc(org.id).collection('items');
                }

                if (collection && !data.newApply && !data.newReject && data.cart && data.cart.items) {
                    const cart = data.cart;
                    await Promise.all(cart.items.map(async (item) => {
                        try {
                            const itemSell = await collection.doc(item.id).get();
                            const itemSellData = itemSell.data();
                            if (!itemSellData) {
                                cart.deletedItem = true;
                                item.deletedItem = true;
                                item.deletedText = '販売終了';
                            } else if (!itemSellData.price || !itemSellData.price[0] || !itemSellData.price[0].price) {
                                cart.deletedItem = true;
                                item.deletedItem = true;
                                item.deletedText = '要見積';
                            } else if (itemSellData.price[0].expiration_date) {
                                let expDate = itemSellData.price[0].expiration_date.toDate();
                                if ((expDate.getTime() - new Date().getTime()) < 0) {
                                    cart.deletedItem = true;
                                    item.deletedItem = true;
                                    item.deletedText = '要見積';
                                } else {
                                    item.price = itemSellData.price[0].price;
                                }
                            } else {
                                item.price = itemSellData.price[0].price;
                            }
                        } catch (e) {
                            console.error("Item validation error:", e);
                        }
                    }));
                }

                this.setState({ data, loading: false });
            } else {
                this.setState({ loading: false });
            }
        } catch (error) {
            console.error("Error fetching order detail:", error);
            this.setState({ loading: false });
        }
    };

    applyFile = (order) => {
        const title = (order.cart?.items?.[0]?.name || '') + ' 計' + (order.cart?.items?.length || 0) + '点';
        this.setState({
            applyModal: true,
            applyId: order.id,
            applyTitle: title,
        });
    };

    rejectFile = (order) => {
        const title = (order.cart?.items?.[0]?.name || '') + ' 計' + (order.cart?.items?.length || 0) + '点';
        this.setState({
            rejectModal: true,
            rejectId: order.id,
            rejectTitle: title,
        });
    };

    waitFile = (order) => {
        this.setState({
            waitModal: true,
            waitId: order.id,
            waitTitle: order.cart?.orderNo || order.id.substring(0, 8),
        });
    };

    applyClose = async () => {
        const esId = this.state.applyId;
        const { db, org, userOrg, user, cProps } = this.props;
        const loadBadge = cProps?.loadBadge;

        this.setState({ applyModal: false, loading: true });

        let collection;
        if (org && org.reseller && userOrg && userOrg.maker) {
            collection = db.collection('items_stock').doc(userOrg.id).collection('buyers').doc(org.id).collection('items');
        } else if (org && org.maker && userOrg && userOrg.reseller) {
            collection = db.collection('items_stock').doc(org.id).collection('buyers').doc(userOrg.id).collection('items');
        } else if (org && org.reseller && userOrg && userOrg.buyer) {
            collection = db.collection('items_sell').doc(userOrg.id).collection('items');
        } else if (org && org.buyer && userOrg && userOrg.reseller) {
            collection = db.collection('items_sell').doc(org.id).collection('items');
        }

        if (esId && collection) {
            try {
                const o = await db.collection('orders').doc(esId).get();
                const data = o.data();
                const cart = data.cart || {};

                await Promise.all(cart.items.map(async (item) => {
                    const itemSell = await collection.doc(item.id).get();
                    const itemSellData = itemSell.data();
                    if (itemSellData && itemSellData['price']) {
                        item.price = itemSellData['price'][0]['price'];
                    }
                }));

                const cartRef = db.collection('carts').doc(data.fromUser).collection('carts').doc(data.toOrganization);
                await cartRef.set({ [data.cartNo]: {} }, { merge: true });

                const username = (user.last_name || '') + ' ' + (user.first_name || '');
                const ordersRef = db.collection('orders').doc(esId);

                const updatePayload = {
                    apply: { [user.id]: true },
                    applied: true,
                    newApply: true,
                    cart,
                    applyUserName: username,
                    orderDate: firebase.firestore.Timestamp.fromDate(new Date()),
                    latestUpdate: firebase.firestore.Timestamp.fromDate(new Date()),
                    sortDate: firebase.firestore.Timestamp.fromDate(new Date()),
                };

                if (user.authorizer) {
                    updatePayload.authorizer_visited = true;
                }

                await ordersRef.set(updatePayload, { merge: true });

                if (loadBadge) loadBadge();
                message.success('発注を承認しました');
                this.fetchOrderData();
            } catch (error) {
                console.error("Apply error:", error);
                message.error('承認中にエラーが発生しました');
            }
        }
        this.setState({ loading: false, applyId: null, applyTitle: null });
    };

    rejectClose = async () => {
        const esId = this.state.rejectId;
        const { db, org, userOrg, user, cProps } = this.props;
        const loadBadge = cProps?.loadBadge;

        this.setState({ rejectModal: false, loading: true });

        let collection;
        if (org && org.reseller && userOrg && userOrg.maker) {
            collection = db.collection('items_stock').doc(userOrg.id).collection('buyers').doc(org.id).collection('items');
        } else if (org && org.maker && userOrg && userOrg.reseller) {
            collection = db.collection('items_stock').doc(org.id).collection('buyers').doc(userOrg.id).collection('items');
        } else if (org && org.reseller && userOrg && userOrg.buyer) {
            collection = db.collection('items_sell').doc(userOrg.id).collection('items');
        } else if (org && org.buyer && userOrg && userOrg.reseller) {
            collection = db.collection('items_sell').doc(org.id).collection('items');
        }

        if (esId && collection) {
            try {
                const ordersRef = db.collection('orders').doc(esId);
                const o = await ordersRef.get();
                const data = o.data();
                const cart = data.cart || {};

                await Promise.all(cart.items.map(async (item) => {
                    const itemSell = await collection.doc(item.id).get();
                    const itemSellData = itemSell.data();
                    if (itemSellData && itemSellData['price']) {
                        item.price = itemSellData['price'][0]['price'];
                    }
                }));

                const cartRef = db.collection('carts').doc(data.fromUser).collection('carts').doc(data.toOrganization);
                await cartRef.set({
                    [data.cartNo]: {
                        requested: false,
                        rejected: true,
                    },
                }, { merge: true });

                const username = (user.last_name || '') + ' ' + (user.first_name || '');
                await ordersRef.set({
                    reject: { [user.id]: true },
                    rejectUserName: username,
                    newReject: true,
                    cart,
                    rejectDate: firebase.firestore.Timestamp.fromDate(new Date()),
                    latestUpdate: firebase.firestore.Timestamp.fromDate(new Date()),
                    sortDate: firebase.firestore.Timestamp.fromDate(new Date()),
                }, { merge: true });

                if (loadBadge) loadBadge();
                message.success('発注を却下しました');
                this.fetchOrderData();
            } catch (error) {
                console.error("Reject error:", error);
                message.error('却下中にエラーが発生しました');
            }
        }
        this.setState({ loading: false, rejectId: null, rejectTitle: null });
    };

    waitClose = async () => {
        const esId = this.state.waitId;
        const { db, user } = this.props;

        this.setState({ waitModal: false, loading: true });

        if (esId) {
            try {
                const ordersRef = db.collection('orders').doc(esId);
                await ordersRef.set({
                    wait: { [user.id]: true },
                }, { merge: true });
                message.success('承認依頼を送信しました');
                this.fetchOrderData();
            } catch (error) {
                console.error("Wait error:", error);
                message.error('承認依頼中にエラーが発生しました');
            }
        }
        this.setState({ loading: false, waitId: null, waitTitle: null });
    };

    getStatusTag = (order) => {
        if (order.cancelConfirmed) return <Tag color="error">キャンセル済</Tag>;
        if (order.returnConfirmed) return <Tag color="warning">返品済</Tag>;
        if (order.isShipped) return <Tag color="success">出荷済</Tag>;
        if (order.sellerConfirm) return <Tag color="processing">受注済</Tag>;
        if (order.applied) return <Tag color="blue">注文済</Tag>;
        if (order.reject) return <Tag color="error">却下済</Tag>;
        return <Tag>未確認</Tag>;
    };

    // Item Action Handlers
    cancelItemModalOpen = (index) => {
        this.setState({ cancelItemModal: true, cancelItemIndex: index });
    };

    cancelItemClose = async (confirmed) => {
        const { cancelItemIndex, data } = this.state;
        const { db, user } = this.props;

        if (!confirmed || cancelItemIndex === null) {
            this.setState({ cancelItemModal: false, cancelItemIndex: null });
            return;
        }

        try {
            this.setState({ itemActionLoading: true });
            const items = [...data.cart.items];
            const item = items[cancelItemIndex];

            const cancelDate = firebase.firestore.Timestamp.now();
            const cancelBy = user.id;
            const cancelByUser = (user.last_name || '') + ' ' + (user.first_name || '');

            item.cancelDate = cancelDate;
            item.cancelBy = cancelBy;
            item.cancelByUser = cancelByUser;
            item.cancelConfirm = false;
            item.cancelReject = false;

            const changeDate = new Date().getTime();
            const updatePayload = {
                cart: { ...data.cart, items },
                cancelDate,
                cancelBy,
                cancelByUser,
                cancelWait: true,
                changeDate,
                latestUpdate: firebase.firestore.Timestamp.fromDate(new Date()),
            };

            await db.collection('orders').doc(data.id).set(updatePayload, { merge: true });

            try {
                const n = (num) => num.toString().padStart(2, '0');
                const cancelDateFormatted = `${cancelDate.toDate().getFullYear()}/${n(cancelDate.toDate().getMonth() + 1)}/${n(cancelDate.toDate().getDate())} ${n(cancelDate.toDate().getHours())}:${n(cancelDate.toDate().getMinutes())}`;
                await firebase.functions().httpsCallable('sendCancelEmail')({
                    orderNo: data.cart.orderNo,
                    cancelDate: cancelDateFormatted,
                    cancelBy,
                    cancelByUser,
                    fromUser: data.fromUser,
                    apply: Object.keys(data.apply || {}),
                    toUser: data.toUser,
                    toUserCC: data.toUserCC,
                    itemName: item.name,
                    toOrganization: data.toOrganization,
                    fromOrganization: data.fromOrganization,
                    orderId: data.id
                });
            } catch (e) {
                console.error("Email error:", e);
            }

            message.success('キャンセル依頼を送信しました');
            this.setState({ cancelItemModal: false, cancelItemIndex: null });
            this.fetchOrderData();
        } catch (error) {
            console.error("Cancel error:", error);
            message.error('キャンセル処理中にエラーが発生しました');
        } finally {
            this.setState({ itemActionLoading: false });
        }
    };

    returnItemModalOpen = (index) => {
        this.setState({ returnItemModal: true, returnItemIndex: index });
    };

    returnItemClose = async (confirmed) => {
        const { returnItemIndex, data } = this.state;
        const { db, user } = this.props;

        if (!confirmed || returnItemIndex === null) {
            this.setState({ returnItemModal: false, returnItemIndex: null });
            return;
        }

        try {
            this.setState({ itemActionLoading: true });
            const items = [...data.cart.items];
            const item = items[returnItemIndex];

            const returnDate = firebase.firestore.Timestamp.now();
            const returnBy = user.id;
            const returnByUser = (user.last_name || '') + ' ' + (user.first_name || '');

            item.returnDate = returnDate;
            item.returnBy = returnBy;
            item.returnByUser = returnByUser;
            item.returnConfirm = false;
            item.returnReject = false;

            const changeDate = new Date().getTime();
            const updatePayload = {
                cart: { ...data.cart, items },
                returnDate,
                returnBy,
                returnByUser,
                returnWait: true,
                changeDate,
                latestUpdate: firebase.firestore.Timestamp.fromDate(new Date()),
            };

            await db.collection('orders').doc(data.id).set(updatePayload, { merge: true });

            try {
                const n = (num) => num.toString().padStart(2, '0');
                const returnDateFormatted = `${returnDate.toDate().getFullYear()}/${n(returnDate.toDate().getMonth() + 1)}/${n(returnDate.toDate().getDate())} ${n(returnDate.toDate().getHours())}:${n(returnDate.toDate().getMinutes())}`;
                await firebase.functions().httpsCallable('sendReturnEmail')({
                    orderNo: data.cart.orderNo,
                    returnDate: returnDateFormatted,
                    returnBy,
                    returnByUser,
                    fromUser: data.fromUser,
                    apply: Object.keys(data.apply || {}),
                    toUser: data.toUser,
                    toUserCC: data.toUserCC,
                    itemName: item.name,
                    toOrganization: data.toOrganization,
                    fromOrganization: data.fromOrganization,
                    orderId: data.id
                });
            } catch (e) {
                console.error("Email error:", e);
            }

            message.success('返品依頼を送信しました');
            this.setState({ returnItemModal: false, returnItemIndex: null });
            this.fetchOrderData();
        } catch (error) {
            console.error("Return error:", error);
            message.error('返品処理中にエラーが発生しました');
        } finally {
            this.setState({ itemActionLoading: false });
        }
    };

    cancelApprove = async (index) => {
        const { data } = this.state;
        const { db, user } = this.props;
        try {
            this.setState({ itemActionLoading: true });
            const items = [...data.cart.items];
            const item = items[index];
            const now = firebase.firestore.Timestamp.now();
            const username = (user.last_name || '') + ' ' + (user.first_name || '');

            item.cancelConfirm = true;
            item.cancelConfirmDate = now;
            item.cancelConfirmByUser = username;

            await db.collection('orders').doc(data.id).set({
                cart: { ...data.cart, items },
                cancelConfirmed: true,
                latestUpdate: now
            }, { merge: true });

            message.success('キャンセルを承認しました');
            this.fetchOrderData();
        } catch (error) {
            console.error(error);
            message.error('エラーが発生しました');
        } finally {
            this.setState({ itemActionLoading: false });
        }
    };

    cancelReject = async (index) => {
        const { data } = this.state;
        const { db, user } = this.props;
        try {
            this.setState({ itemActionLoading: true });
            const items = [...data.cart.items];
            const item = items[index];
            const now = firebase.firestore.Timestamp.now();
            const username = (user.last_name || '') + ' ' + (user.first_name || '');

            item.cancelReject = true;
            item.cancelRejectDate = now;
            item.cancelRejectByUser = username;

            await db.collection('orders').doc(data.id).set({
                cart: { ...data.cart, items },
                latestUpdate: now
            }, { merge: true });

            message.success('キャンセル依頼を却下しました');
            this.fetchOrderData();
        } catch (error) {
            console.error(error);
            message.error('エラーが発生しました');
        } finally {
            this.setState({ itemActionLoading: false });
        }
    };

    returnApprove = async (index) => {
        const { data } = this.state;
        const { db, user } = this.props;
        try {
            this.setState({ itemActionLoading: true });
            const items = [...data.cart.items];
            const item = items[index];
            const now = firebase.firestore.Timestamp.now();
            const username = (user.last_name || '') + ' ' + (user.first_name || '');

            item.returnConfirm = true;
            item.returnConfirmDate = now;
            item.returnConfirmByUser = username;

            await db.collection('orders').doc(data.id).set({
                cart: { ...data.cart, items },
                returnConfirmed: true,
                latestUpdate: now
            }, { merge: true });

            message.success('返品を承認しました');
            this.fetchOrderData();
        } catch (error) {
            console.error(error);
            message.error('エラーが発生しました');
        } finally {
            this.setState({ itemActionLoading: false });
        }
    };

    returnReject = async (index) => {
        const { data } = this.state;
        const { db, user } = this.props;
        try {
            this.setState({ itemActionLoading: true });
            const items = [...data.cart.items];
            const item = items[index];
            const now = firebase.firestore.Timestamp.now();
            const username = (user.last_name || '') + ' ' + (user.first_name || '');

            item.returnReject = true;
            item.returnRejectDate = now;
            item.returnRejectByUser = username;

            await db.collection('orders').doc(data.id).set({
                cart: { ...data.cart, items },
                latestUpdate: now
            }, { merge: true });

            message.success('返品依頼を却下しました');
            this.fetchOrderData();
        } catch (error) {
            console.error(error);
            message.error('エラーが発生しました');
        } finally {
            this.setState({ itemActionLoading: false });
        }
    };


    formatDate = (timestamp) => {
        if (!timestamp) return '---';
        const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp._seconds * 1000 || timestamp);
        const n = (num) => num.toString().padStart(2, '0');
        return `${date.getFullYear()}/${n(date.getMonth() + 1)}/${n(date.getDate())} ${n(date.getHours())}:${n(date.getMinutes())}`;
    };

    getItemNo = (items) => {
        const n = (num) => num > 9 ? "" + num : "0" + num;
        let no = 0;
        let subDividedNo = 1;
        let returnSubNo = 1;

        return items.map((item) => {
            let templatedNo;
            if (item.subDivided) {
                templatedNo = n(no) + '-' + subDividedNo;
                if (item.returnSub) {
                    templatedNo = n(no) + '-' + (subDividedNo - 1) + '-' + returnSubNo;
                    returnSubNo += 1;
                } else {
                    returnSubNo = 1;
                    subDividedNo += 1;
                }
            } else {
                if (item.returnSub) {
                    templatedNo = n(no) + '-' + returnSubNo;
                    returnSubNo += 1;
                } else {
                    no += 1;
                    subDividedNo = 1;
                    returnSubNo = 1;
                    templatedNo = n(no);
                }
            }
            return { ...item, displayNo: templatedNo };
        });
    };

    renderStatusDot = (item, order) => {
        let dotStyle = { width: 10, height: 10, borderRadius: 5, display: 'inline-block' };
        let color = '#FF3547'; // Default red

        if (item.okurijyoNo) {
            const lastOkurijyo = item.okurijyoNo.slice(-1)[0];
            const okurijyoNo = lastOkurijyo.value;
            const hassouDate = lastOkurijyo.hassouDate;
            const latestUpdate = lastOkurijyo.latestUpdate;
            const shippingDate = lastOkurijyo.shippingDate;

            try {
                if (latestUpdate && shippingDate) {
                    const luTime = latestUpdate.toDate ? latestUpdate.toDate().getTime() : new Date(latestUpdate._seconds * 1000).getTime();
                    const shTime = shippingDate.toDate ? shippingDate.toDate().getTime() : new Date(shippingDate._seconds * 1000).getTime();
                    if (okurijyoNo && hassouDate && (luTime === shTime)) {
                        color = '#19A22B'; // Shipped green
                    }
                } else if (hassouDate) {
                    color = '#19A22B';
                }
            } catch (e) {
                console.error(e);
            }
        }

        if (item.cancelConfirm === false && item.cancelReject === false) {
            color = '#ff63e0'; // Cancel wait
            dotStyle.borderRadius = 0;
        } else if (item.cancelConfirm === true) {
            color = '#ff63e0'; // Cancel confirm
        } else if (item.returnConfirm === false && item.returnReject === false) {
            color = '#00C2FF'; // Return wait
            dotStyle.borderRadius = 0;
        } else if (item.returnConfirm === true) {
            color = '#00C2FF'; // Return confirm
        }

        return <div style={{ ...dotStyle, backgroundColor: color }} />;
    };

    checkShippingStatus = (item) => {
        if (!item.okurijyoNo) return 'unShipped';
        const lastOkurijyo = item.okurijyoNo.slice(-1)[0];
        const okurijyoNo = lastOkurijyo.value;
        const hassouDate = lastOkurijyo.hassouDate;
        const latestUpdate = lastOkurijyo.latestUpdate;
        const shippingDate = lastOkurijyo.shippingDate;

        if (latestUpdate && shippingDate) {
            const luTime = latestUpdate.toDate ? latestUpdate.toDate().getTime() : new Date(latestUpdate._seconds * 1000).getTime();
            const shTime = shippingDate.toDate ? shippingDate.toDate().getTime() : new Date(shippingDate._seconds * 1000).getTime();
            if (okurijyoNo && hassouDate && (luTime === shTime)) return 'shipped';
        } else if (hassouDate) {
            return 'shipped';
        }
        return 'unShipped';
    };

    showCancelMenu = (order, item) => {
        if (!item.divided &&
            !(item.divided && item.divideConfirm === false) &&
            ((!(item.subDivided === true && item.divideConfirm === false) && item.cancelConfirm === undefined && item.returnConfirm === undefined) || (!(item.subDivided === true && item.divideConfirm === false) && (item.cancelReject === true && item.cancelConfirm !== true && item.returnConfirm !== true || item.returnReject === true && item.cancelConfirm !== true && item.returnConfirm !== true))) &&
            !item.returnMain &&
            !(item.cancelConfirm === false && item.cancelReject === false || item.returnConfirm === false && item.returnReject === false) && order.newApply
        ) {
            return true;
        }
        return false;
    };


    renderDeliveryAddress = (cartData, data) => {
        const deliveryAddress = cartData.deliveryAddress || {};
        const otasukeDeliveryAddress = cartData.otasukeDeliveryAddress || {};
        const { userOrg } = this.props;

        switch (cartData.orderBasyo) {
            case '登録住所':
                return (
                    <div>
                        (登録住所)<br />
                        {userOrg.zipcode}<br />
                        {userOrg.address}<br />
                        {userOrg.display_name}<br />
                        受取担当者：{data.fromUserName}<br />
                        電話番号：{userOrg.TEL}
                    </div>
                );
            case '登録住所以外':
                return (
                    <div>
                        (登録住所以外)<br />
                        {cartData.orderZipcode}<br />
                        {cartData.orderAddr1}<br />
                        {cartData.orderAddr2}<br />
                        {cartData.orderJigyosyo}<br />
                        受取担当者：{cartData.orderTanto}<br />
                        電話番号：{cartData.orderPhone}
                    </div>
                );
            case '前回の納品先':
            case 'アドレス帳から選択する':
                const label = cartData.orderBasyo === '前回の納品先' ? '(前回の納品先)' : '(アドレス帳から選択する)';
                return (
                    <div>
                        {label}<br />
                        {deliveryAddress.propertyName}<br />
                        {deliveryAddress.postCode}<br />
                        {deliveryAddress.address1}<br />
                        {deliveryAddress.address2}<br />
                        {deliveryAddress.officeName}<br />
                        受取担当者：{deliveryAddress.personInCharge}<br />
                        電話番号：{deliveryAddress.phoneNumber}
                    </div>
                );
            case '販売側からお助けカートで指定された納品先':
                return (
                    <div>
                        (販売側からお助けカートで指定された納品先)<br />
                        {otasukeDeliveryAddress.propertyName}<br />
                        {otasukeDeliveryAddress.postCode}<br />
                        {otasukeDeliveryAddress.address1}<br />
                        {otasukeDeliveryAddress.address2}<br />
                        {otasukeDeliveryAddress.officeName}<br />
                        受取担当者：{otasukeDeliveryAddress.personInCharge}<br />
                        電話番号：{otasukeDeliveryAddress.phoneNumber}
                    </div>
                );
            case '納品先を直接入力する':
                return (
                    <div>
                        (納品先を直接入力する)<br />
                        {cartData.orderPropertyName}<br />
                        {cartData.orderZipcode}<br />
                        {cartData.orderAddr1}<br />
                        {cartData.orderAddr2}<br />
                        {cartData.orderJigyosyo}<br />
                        受取担当者：{cartData.orderTanto}<br />
                        電話番号：{cartData.orderPhone}
                    </div>
                );
            default:
                return <div>{cartData.orderAddr1} {cartData.orderAddr2}</div>;
        }
    };

    render() {
        const { loading, data } = this.state;
        const history = this.props.cProps?.history;
        const { user, userOrg, org } = this.props;

        let kaigawa = false;
        let urigawa = false;
        if ((userOrg && userOrg.buyer && org && org.reseller) || (userOrg && userOrg.reseller && org && org.maker)) {
            kaigawa = true;
        }
        if ((userOrg && userOrg.reseller && org && org.buyer) || (userOrg && userOrg.maker && org && org.reseller)) {
            urigawa = true;
        }

        // Robust checks like OrderTableList.js
        const showApproveReject = kaigawa && user.authorizer && 
            (!data.apply || Object.keys(data.apply).length === 0) && 
            (!data.reject || Object.keys(data.reject).length === 0);
        
        const showWait = kaigawa && !user.authorizer && 
            (!data.wait || Object.keys(data.wait).length === 0) && 
            (!data.apply || Object.keys(data.apply).length === 0) && 
            data.toUser === user.id;

        if (loading) {
            return (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <Spin size="large" tip="読み込み中..." />
                </div>
            );
        }

        if (!data.id) {
            return <div style={{ padding: '20px' }}>注文が見つかりませんでした。</div>;
        }

        const cart = data.cart || {};
        const items = cart.items || [];

        let subtotal = 0;
        let mainTotal = 0;
        let cancelTotal = 0;
        let returnTotal = 0;
        let taxes = {};
        let taxTotal = 0;

        items.forEach(item => {
            if (!item.deletedItem && !item.divided) {
                const itemTax = item.tax || 0.1;
                const itemPriceTotal = item.count * item.price;

                if (item.returnConfirm) {
                    returnTotal += itemPriceTotal;
                }

                if (item.cancelConfirm) {
                    cancelTotal += itemPriceTotal;
                } else {
                    subtotal += itemPriceTotal;
                    if (taxes[itemTax]) {
                        taxes[itemTax] += Math.floor(itemPriceTotal * itemTax);
                    } else {
                        taxes[itemTax] = Math.floor(itemPriceTotal * itemTax);
                    }
                    taxTotal += Math.floor(itemPriceTotal * itemTax);
                }

                if (!item.returnSub) {
                    mainTotal += itemPriceTotal;
                }
            }
        });

        const postage = data.postage || 0;
        const total = subtotal + taxTotal + postage;

        const orderDate = data.orderDate || data.created;
        const updateDate = data.latestUpdate || data.created;

        return (
            <div className="mobile-order-detail-container">
                {/* Header */}
                <div className="mobile-order-detail-header">
                    <Space direction="vertical" style={{ width: '100%' }}>
                        <Button
                            type="link"
                            icon={<LeftOutlined />}
                            onClick={() => history && history.goBack ? history.goBack() : window.history.back()}
                            style={{ padding: 0 }}
                        >
                            戻る
                        </Button>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                            <div>
                                <Title level={4} style={{ margin: 0 }}>発注書</Title>
                                <Text type="secondary" style={{ fontSize: '13px' }}>{this.formatDate(orderDate)}</Text>
                            </div>
                            {this.getStatusTag(data)}
                        </div>
                    </Space>
                </div>

                {/* Items Section */}
                <div className="section-title" style={{ padding: '16px 16px 8px 16px' }}>
                    <Text strong>商品明細</Text>
                </div>
                <List
                    dataSource={this.getItemNo(items)}
                    renderItem={(item, index) => {
                        const noukiSDate = item.nouki?.slice(-1)[0]?.sdate ? this.formatDate(item.nouki.slice(-1)[0].sdate).split(' ')[0] : '';
                        const noukiEDate = item.nouki?.slice(-1)[0]?.edate ? this.formatDate(item.nouki.slice(-1)[0].edate).split(' ')[0] : '';
                        const okurijyoNo = item.okurijyoNo?.slice(-1)[0]?.value || '';
                        const hassouDate = item.okurijyoNo?.slice(-1)[0]?.hassouDate ? this.formatDate(item.okurijyoNo.slice(-1)[0].hassouDate).split(' ')[0] : '';
                        const isShipped = this.checkShippingStatus(item) === 'shipped';
                        const showActions = this.showCancelMenu(data, item);

                        return (
                            <Card className="item-detail-card" key={index} style={{ opacity: item.cancelConfirm || item.returnConfirm ? 0.6 : 1 }}>
                                <div className="item-card-header-row">
                                    <div className="item-no-status">
                                        <Text strong>{item.displayNo}</Text>
                                        {item.subDivided && (
                                            <Tag color={item.divideConfirm ? "default" : "error"} size="small">
                                                {item.divideConfirm ? "分納" : "分納手続中"}
                                            </Tag>
                                        )}
                                        {item.cancelConfirm === false && item.cancelReject === false && <Tag color="error">キャンセル依頼中</Tag>}
                                        {item.cancelConfirm === true && <Tag color="error">キャンセル済</Tag>}
                                        {item.returnConfirm === false && item.returnReject === false && <Tag color="processing">返品依頼中</Tag>}
                                        {item.returnConfirm === true && <Tag color="processing">返品済</Tag>}
                                    </div>
                                    <div className="item-indicators">
                                        {this.renderStatusDot(item, data)}
                                    </div>
                                </div>
                                <Divider style={{ margin: '8px 0' }} />
                                <div className="item-card-content">
                                    <div className="item-info">
                                        <Text strong className="item-name" style={{ display: 'block', marginBottom: '4px' }}>{item.name}</Text>
                                        <Text type="secondary" style={{ fontSize: '12px', display: 'block' }}>メーカー: {item.maker}</Text>
                                        <Text type="secondary" style={{ fontSize: '12px', display: 'block' }}>商品コード: {kaigawa ? item.code : `${item.sellercode}/${item.code}`}</Text>
                                        {(!kaigawa && item.makeredicode) && (
                                            <Text type="secondary" style={{ fontSize: '12px', display: 'block' }}>{item.makeredicode}/{item.makerordercode}</Text>
                                        )}
                                    </div>

                                    <Divider style={{ margin: '8px 0' }} />

                                    <Descriptions column={2} size="small" className="item-meta-info" colon={false}>
                                        <Descriptions.Item label="単価/数量" span={2}>
                                            <div style={{ textAlign: 'right', width: '100%' }}>
                                                <Text type="secondary" style={{ fontSize: '12px' }}>@{item.price.toLocaleString()}円</Text>
                                                <Text strong style={{ marginLeft: '12px', fontSize: '16px' }}>{item.count.toLocaleString()}</Text>
                                            </div>
                                        </Descriptions.Item>
                                        <Descriptions.Item label="金額" span={2}>
                                            <div style={{ textAlign: 'right', width: '100%' }}>
                                                <Text strong type={item.cancelConfirm || item.returnConfirm ? "secondary" : "danger"} style={{ fontSize: '16px' }}>
                                                    ¥{(item.price * item.count).toLocaleString()}
                                                </Text>
                                            </div>
                                        </Descriptions.Item>
                                        <Descriptions.Item label="納期回答" span={2}>
                                            <div style={{ textAlign: 'right', width: '100%', fontSize: '13px' }}>
                                                {noukiSDate}{noukiEDate && ` 〜 ${noukiEDate}`}
                                            </div>
                                        </Descriptions.Item>
                                        <Descriptions.Item label="出荷日/送り状" span={2}>
                                            <div style={{ textAlign: 'right', width: '100%', fontSize: '13px' }}>
                                                {hassouDate} / {okurijyoNo}
                                            </div>
                                        </Descriptions.Item>
                                        {(item.cancelByUser || item.returnByUser) && (
                                            <Descriptions.Item label="依頼情報" span={2}>
                                                <div style={{ fontSize: '11px', color: '#888' }}>
                                                    {item.cancelByUser && <div>キャンセル依頼: {item.cancelByUser} ({this.formatDate(item.cancelDate)})</div>}
                                                    {item.returnByUser && <div>返品依頼: {item.returnByUser} ({this.formatDate(item.returnDate)})</div>}
                                                </div>
                                            </Descriptions.Item>
                                        )}
                                        {item.noukiComment && (
                                            <Descriptions.Item label="備考" span={2}>
                                                <div style={{ fontSize: '12px', color: '#666' }}>{item.noukiComment}</div>
                                            </Descriptions.Item>
                                        )}
                                    </Descriptions>

                                    {/* Item Actions */}
                                    {(showActions || urigawa) && (
                                        <>
                                            <Divider style={{ margin: '8px 0' }} />
                                            <div className="item-actions-row" style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                                                {kaigawa && showActions && (
                                                    !isShipped ? (
                                                        <Button size="small" danger onClick={() => this.cancelItemModalOpen(index)}>注文キャンセル</Button>
                                                    ) : (
                                                        <Button size="small" type="primary" onClick={() => this.returnItemModalOpen(index)}>返品</Button>
                                                    )
                                                )}
                                                {urigawa && (
                                                    <>
                                                        {item.cancelConfirm === false && item.cancelReject === false && (
                                                            <Space>
                                                                <Button size="small" type="primary" onClick={() => this.cancelApprove(index)}>キャンセル承認</Button>
                                                                <Button size="small" danger onClick={() => this.cancelReject(index)}>キャンセル却下</Button>
                                                            </Space>
                                                        )}
                                                        {item.returnConfirm === false && item.returnReject === false && (
                                                            <Space>
                                                                <Button size="small" type="primary" onClick={() => this.returnApprove(index)}>返品承認</Button>
                                                                <Button size="small" danger onClick={() => this.returnReject(index)}>返品却下</Button>
                                                            </Space>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </Card>
                        );

                    }}
                />

                {/* Summary Section */}
                <div className="section-title" style={{ padding: '16px 16px 8px 16px' }}>
                    <Text strong>合計金額</Text>
                </div>
                <Card className="summary-card">
                    <Descriptions column={1} size="small" colon={false}>
                        <Descriptions.Item label="運賃">
                            <div style={{ textAlign: 'right', width: '100%' }}>¥{postage.toLocaleString()}</div>
                        </Descriptions.Item>
                        <Descriptions.Item label="小計">
                            <div style={{ textAlign: 'right', width: '100%' }}>¥{mainTotal.toLocaleString()}</div>
                        </Descriptions.Item>
                        {cancelTotal > 0 && (
                            <Descriptions.Item label="キャンセル">
                                <div style={{ textAlign: 'right', width: '100%' }}>-¥{cancelTotal.toLocaleString()}</div>
                            </Descriptions.Item>
                        )}
                        {returnTotal > 0 && (
                            <Descriptions.Item label="返品">
                                <div style={{ textAlign: 'right', width: '100%' }}>¥{returnTotal.toLocaleString()}</div>
                            </Descriptions.Item>
                        )}
                        <Descriptions.Item label="消費税額計">
                            <div style={{ textAlign: 'right', width: '100%' }}>¥{taxTotal.toLocaleString()}</div>
                        </Descriptions.Item>
                        {Object.keys(taxes).sort((a, b) => b - a).map(rate => (
                            <Descriptions.Item key={rate} label={`消費税${rate * 100}%`}>
                                <div style={{ textAlign: 'right', width: '100%', color: '#8c8c8c' }}>¥{taxes[rate].toLocaleString()}</div>
                            </Descriptions.Item>
                        ))}
                        <Divider style={{ margin: '8px 0' }} />
                        <Descriptions.Item label={<Text strong style={{ fontSize: '16px' }}>合計</Text>}>
                            <div style={{ textAlign: 'right', width: '100%' }}>
                                <Text strong style={{ fontSize: '18px', color: '#d32f2f' }}>¥{total.toLocaleString()}</Text>
                            </div>
                        </Descriptions.Item>
                    </Descriptions>
                </Card>

                {/* Order Information List */}
                <div className="section-title" style={{ padding: '16px 16px 8px 16px' }}>
                    <Text strong>注文情報</Text>
                </div>
                <Card className="info-list-card">
                    <Descriptions column={1} size="small" bordered className="mobile-descriptions">
                        <Descriptions.Item label="発注番号">{cart.orderNo || '---'}</Descriptions.Item>
                        <Descriptions.Item label="発注日時">{this.formatDate(orderDate)}</Descriptions.Item>
                        <Descriptions.Item label="更新日時">{this.formatDate(updateDate)}</Descriptions.Item>
                        <Descriptions.Item label="発注者">{data.fromUserName || '---'}</Descriptions.Item>
                        <Descriptions.Item label="納品場所">{this.renderDeliveryAddress(cart, data)}</Descriptions.Item>
                        <Descriptions.Item label="希望納期">
                            {cart.orderNouki === '最短' ? '最短' :
                                cart.orderNouki === '希望' ? `${cart.orderNoukiDay}日` :
                                    this.formatDate(cart.orderNoukiDate).split(' ')[0]}
                        </Descriptions.Item>
                        <Descriptions.Item label="備考">{cart.orderBikou ? nl2br(cart.orderBikou) : '---'}</Descriptions.Item>
                    </Descriptions>
                </Card>

                {/* Bottom Actions */}
                <div className="bottom-actions-container">
                    {showApproveReject ? (
                        <div className="authorization-actions">
                            <Button
                                type="primary"
                                className="approve-btn-large"
                                onClick={() => this.applyFile(data)}
                                disabled={data.cart && data.cart.deletedItem}
                            >
                                承認（発注確定）確認
                            </Button>
                            <Button
                                type="primary"
                                className="reject-btn-large"
                                onClick={() => this.rejectFile(data)}
                            >
                                却下（担当者に差戻）確認
                            </Button>
                        </div>
                    ) : showWait ? (
                        <div className="authorization-actions">
                            <Button
                                type="primary"
                                className="wait-btn-large"
                                onClick={() => this.waitFile(data)}
                            >
                                承認依頼
                            </Button>
                        </div>
                    ) : null}
                </div>

                {/* Approve Modal */}
                <Modal
                    title="承認(発注確定)"
                    open={this.state.applyModal}
                    onOk={this.applyClose}
                    onCancel={() => this.setState({ applyModal: false, applyId: null, applyTitle: null })}
                    okText="承認(発注確定)する"
                    cancelText="キャンセル"
                >
                    <p>{this.state.applyTitle} の発注を承認しますか？</p>
                    <p>承認すると発注が確定し、販売会社に通知されます。</p>
                </Modal>

                {/* Reject Modal */}
                <Modal
                    title="発注却下"
                    open={this.state.rejectModal}
                    onOk={this.rejectClose}
                    onCancel={() => this.setState({ rejectModal: false, rejectId: null, rejectTitle: null })}
                    okText="却下する"
                    okButtonProps={{ danger: true }}
                    cancelText="キャンセル"
                >
                    <p>{this.state.rejectTitle} の発注を却下しますか？</p>
                </Modal>

                {/* Wait (Request Approval) Modal */}
                <Modal
                    title="承認依頼"
                    open={this.state.waitModal}
                    onOk={this.waitClose}
                    onCancel={() => this.setState({ waitModal: false, waitId: null, waitTitle: null })}
                    okText="上長に承認依頼する"
                    cancelText="キャンセル"
                >
                    <p>発注番号: {this.state.waitTitle} の発注について、上長に承認依頼をします。</p>
                </Modal>

                {/* Item Cancel Modal */}
                <Modal
                    title="注文キャンセル依頼"
                    open={this.state.cancelItemModal}
                    onOk={() => this.cancelItemClose(true)}
                    onCancel={() => this.cancelItemClose(false)}
                    confirmLoading={this.state.itemActionLoading}
                    okText="キャンセルを依頼する"
                    cancelText="中止する"
                    okButtonProps={{ danger: true }}
                >
                    <p>この商品の注文キャンセルを依頼します。よろしいですか？</p>
                </Modal>

                {/* Item Return Modal */}
                <Modal
                    title="返品依頼"
                    open={this.state.returnItemModal}
                    onOk={() => this.returnItemClose(true)}
                    onCancel={() => this.returnItemClose(false)}
                    confirmLoading={this.state.itemActionLoading}
                    okText="返品を依頼する"
                    cancelText="中止する"
                    okButtonProps={{ type: 'primary' }}
                >
                    <p>この商品の返品を依頼します。よろしいですか？</p>
                </Modal>
            </div>
        );
    }
}


export default MobileOrderDetail;
